import glamorous from 'glamorous';
import { borderWidth, padding } from 'polished';

const StaticItem = glamorous.li(props => ({
  alignItems: 'center',
  borderColor: 'rgba(100, 100, 100, 0.25)',
  ...borderWidth('0', '0', 1),
  display: 'flex',
  ...padding(props.theme.spacing.xsmall, null),
  borderStyle: props.underline ? 'solid' : 'none',
  [props.theme.mediaQuery.desktopAndUp]: {
    border: 0,
    flexDirection: 'row',
    ...padding(null, props.theme.spacing.small),
  },
}));

export default StaticItem;
